import React from 'react'

import OrgReports from '../../org/reports'

export default function GroupReports() {
  return (
    <OrgReports isGroupAdminMode />
  )
}
